const NOT_STARTED = 'Not Started';
const ATTEMPTING_KBAS = 'Attempting KBAs';

const STEP_LABELS: Record<string, string> = {
  Consents: 'Agreeing to Consents',
  DeviceSetup: 'Checking Hardware',
  ParticipantRegistration: 'Completing Profile',
  IdentityVerification: 'Verifying Identity',
  SignatureSelection: 'Selecting Signatures',
  Presign: 'Signing Documents',
  PresignComplete: 'Waiting for Others',
  WaitingRoom: 'Waiting to Join',
};

const KBA_STATUS_LABELS: Record<string, string> = {
  InProgress: ATTEMPTING_KBAS,
  Failed: 'KBAs Failed',
};

export function getEsignParticipantStepLabel(currentStep: string, stepStatus: string): string {
  if (!currentStep) {
    return NOT_STARTED;
  }

  if (currentStep === 'KnowledgeBasedAuth') {
    return KBA_STATUS_LABELS[stepStatus] ?? ATTEMPTING_KBAS;
  }

  return STEP_LABELS[currentStep] ?? currentStep;
}
